// Load native Shopify recommendations as JSON instead of requesting an unavailable HTML partial.
class ProductRecommendations extends HTMLElement {
  #controller;
  connectedCallback() {
    if (this.dataset.performed === 'true') return;
    this.#load();
  }
  disconnectedCallback() { this.#controller?.abort(); }
  async #load() {
    this.#controller = new AbortController();
    const url = new URL(this.dataset.url, location.origin);
    url.pathname = url.pathname.replace(/\/$/, '') + '.json';
    url.searchParams.set('product_id', this.dataset.productId);
    this.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url, { signal: this.#controller.signal });
      if (!response.ok) throw new Error('Recommendations unavailable');
      const data = await response.json();
      const products = data.products.filter(product => product.available && !product.tags?.includes('preventa')).slice(0, 4);
      if (!products.length) { this.hidden = true; return; }
      const grid = document.createElement('div');
      grid.className = 'grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4';
      const currency = window.Shopify?.currency?.active || 'CLP';
      const format = new Intl.NumberFormat(document.documentElement.lang || 'es-CL', { style: 'currency', currency });
      for (const product of products) {
        const card = document.createElement('a');
        card.href = product.url;
        card.className = 'block overflow-hidden rounded-card border border-border bg-surface-secondary p-3 focus-visible:outline-2 focus-visible:outline-accent';
        const image = document.createElement('img');
        image.src = product.featured_image;
        image.alt = product.title;
        image.loading = 'lazy';
        image.width = 400;
        image.height = 400;
        image.className = 'aspect-square w-full rounded-card object-contain';
        const title = document.createElement('h3');
        title.textContent = product.title;
        title.className = 'mt-3 line-clamp-2 text-sm font-medium text-on-surface';
        const price = document.createElement('p');
        price.textContent = format.format(product.price / 100);
        price.className = 'mt-2 text-sm text-on-surface';
        card.append(image, title, price);
        grid.append(card);
      }
      this.querySelector('[data-recommendation-results]')?.replaceChildren(grid);
      this.hidden = false;
      this.dataset.performed = 'true';
    } catch (error) {
      if (error.name !== 'AbortError') this.hidden = true;
    } finally { this.removeAttribute('aria-busy'); }
  }
}
if (!customElements.get('s-product-recommendations')) customElements.define('s-product-recommendations', ProductRecommendations);
